module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "return-panel"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), (_vm.sameMedDrugStorage.length !== 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sameMedDrugStorage), function(storage) {
    return _c('div', {
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "cmpn-button",
      on: {
        "click": function($event) {
          return _vm.setNextDrugStorage(storage)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(_vm._f("readableDevice")(storage.device)))]), _c('p', [_vm._v(_vm._s(storage.stock) + " / " + _vm._s(storage.max_stock))]), _c('p', [_vm._v("批號:"), (storage.patch_number !== '' && storage.patch_number !== null && storage.patch_number !== undefined) ? _c('span', [_vm._v(_vm._s(storage.patch_number))]) : _c('span', [_vm._v("未設定")])])])])
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body--title"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("此藥物存放於多藥盒，請選擇欲補充藥盒")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6097c882","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/RefillSelection.vue
// module id = 1488
// module chunks = 1